export default "__VITE_ASSET__XQHQJbDT__"